import { render, staticRenderFns } from "./Import&Export.vue?vue&type=template&id=471679f4&scoped=true&"
import script from "./Import&Export.vue?vue&type=script&lang=js&"
export * from "./Import&Export.vue?vue&type=script&lang=js&"
import style0 from "./Import&Export.vue?vue&type=style&index=0&id=471679f4&prod&scoped=true&lang=css&"
import style1 from "./Import&Export.vue?vue&type=style&index=1&id=471679f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471679f4",
  null
  
)

export default component.exports